import { render, staticRenderFns } from "./Translation.vue?vue&type=template&id=d7b31f9e&scoped=true"
import script from "./Translation.vue?vue&type=script&lang=js"
export * from "./Translation.vue?vue&type=script&lang=js"
import style0 from "./Translation.vue?vue&type=style&index=0&id=d7b31f9e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7b31f9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/OKEY-front_sY8I/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7b31f9e')) {
      api.createRecord('d7b31f9e', component.options)
    } else {
      api.reload('d7b31f9e', component.options)
    }
    module.hot.accept("./Translation.vue?vue&type=template&id=d7b31f9e&scoped=true", function () {
      api.rerender('d7b31f9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Translation.vue"
export default component.exports